(() => {
  const initialized = new WeakSet();

  function setup(root) {
    if (initialized.has(root)) return;
    const video = root.querySelector('[data-wwvb-video]');
    const src = root.dataset.src;
    if (!src || !video) return;
    initialized.add(root);

    const get = key => root.querySelector(`[data-wwvb-${key}]`);
    const overlay = get('overlay');
    const home = get('media');
    const dialog = get('dialog');
    const sound = get('sound');
    const bubble = get('open');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.controls = false;

    document.body.append(root);
    let loaded = false;
    let open = false;
    let previousFocus;

    const load = () => {
      if (loaded) return;
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.append(source);
      video.load();
      loaded = true;
    };

    video.addEventListener('playing', () => {
      if (!open) home.classList.add('is-playing');
    });
    video.addEventListener('pause', () => {
      home.classList.remove('is-playing');
    });

    const play = () => {
      if (document.hidden || !root.isConnected) return;
      load();
      const result = video.play();
      if (result && typeof result.catch === 'function') {
        result.catch(() => {
          if (!open) home.classList.remove('is-playing');
        });
      }
    };

    function close() {
      if (!open) return;
      open = false;
      video.pause();
      video.muted = true;
      video.controls = false;
      home.append(video);
      home.classList.remove('is-playing');
      if (overlay.open) overlay.close();
      sound.textContent = '🔇 Ativar som';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
      play();
    }

    bubble.addEventListener('click', () => {
      previousFocus = bubble;
      open = true;
      load();
      video.pause();
      try { video.currentTime = 0; } catch (error) {
        video.addEventListener('loadedmetadata', () => { video.currentTime = 0; }, { once: true });
      }
      home.classList.remove('is-playing');
      get('stage').append(video);
      video.controls = true;
      if (!overlay.open) overlay.showModal();
      dialog.focus();
      video.muted = false;
      video.volume = 1;
      sound.textContent = '🔊 Silenciar';
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(error => {
          if (!open) return;
          if (error && error.name === 'NotAllowedError') {
            video.muted = true;
            sound.textContent = '🔇 Ativar som';
            video.play().catch(() => {});
          }
        });
      }
    });

    root.querySelectorAll('[data-wwvb-close]').forEach(el => el.addEventListener('click', close));

    overlay.addEventListener('cancel', event => {
      event.preventDefault();
      close();
    });

    sound.addEventListener('click', () => {
      video.muted = !video.muted;
      sound.textContent = video.muted ? '🔇 Ativar som' : '🔊 Silenciar';
      play();
    });

    root.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key !== 'Tab' || !open) return;
      const controls = [...dialog.querySelectorAll('button:not(:disabled)')];
      const first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('visibilitychange', () => document.hidden ? video.pause() : play());

    const start = () => { if (root.isConnected) play(); };
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(start, { timeout: 2500 });
    else if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }

  const boot = () => document.querySelectorAll('[data-wwvb]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
